import {
  ALL_DATAMAP_NODES_BY_CUBE_NODES_REQUEST,
  SET_DATAMAP_DETAILS,
  SET_GRAPH_NODES_LIST,
  SET_DATAMAP_USER_DETAILS,
  SET_DATAMAP_LOADER,
  CLEAR_DATA_MAP,
  SET_PUBLIC_DB_ACCESS_DETAILS,
  SET_FILE_REVOKE_LIST,
  DATA_MAP_SNACKBAR_MESSAGE,
  CLEAR_DATA_MAP_SNACKBAR_MESSAGE,
  SET_USER_AUDIT_TRAIL,
  SET_DATA_SOURCE_AUDIT_TRAIL,
} from "../constants/constants";

const initialState = {
  requestBody_AllDatamapNodes: {},
  loader: false,
  nodesList: {},
  filterId: '',
  dataMapUserNodes: [],
  graphNodesList: {
    apiSucc: false,
    data: {
      nodes: [],
      edges: [],
    },
  },
  dataMapFilePopUp: false,
  dataMapFilePopUpData: {},
  publicDBAccessDetails: [],
  fileRevokeList: [],
  snackBarMessage: {
    apiSuccess: "",
    message: "" 
  },
  userAuditTrail: {},
  dataSourceAuditTrail: {},
};

export const dataMapReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_DATAMAP_NODES_BY_CUBE_NODES_REQUEST: {
      return {
        ...state,
        requestBody_AllDatamapNodes: action.payload,
      };
    }
    case SET_DATAMAP_DETAILS: {
      return {
        ...state,
        dataMapNodes: action.payload
      }
    }
    case SET_DATAMAP_USER_DETAILS: {
      return {
        ...state,
        dataMapUserNodes: action.payload,
        size: action.size,
        type: action.criteriaType
      }
    }
    case SET_GRAPH_NODES_LIST: {
      return {
        ...state,
        graphNodesList: action.payload,
        filterId: action.filterId
      }
    }
    case SET_DATAMAP_LOADER: {
      return {
        ...state,
        loader: action.payload,
      };
    }
    case SET_PUBLIC_DB_ACCESS_DETAILS: {
      return {
        ...state,
        publicDBAccessDetails: action.payload
      }
    }
    case CLEAR_DATA_MAP: {
      return {
        ...state,
        filterId: '',
        dataMapUserNodes: [],
        graphNodesList: {
          apiSucc: false,
          data: {
            nodes: [],
            edges: [],
          },
        }
      };
    }
    case SET_FILE_REVOKE_LIST: {
      return {
        ...state,
        fileRevokeList: action.payload
      }
    }
    case DATA_MAP_SNACKBAR_MESSAGE: {
      return {
        ...state,
        snackBarMessage: action.payload
      }
    }
    case CLEAR_DATA_MAP_SNACKBAR_MESSAGE: {
      return {
        ...state,
        snackBarMessage: {
          apiSuccess: "",
          message: ""
        }
      }
    }
    case "OPEN_FILE_POP_UP": {
      return {
        ...state,
        dataMapFilePopUp: true,
        dataMapFilePopUpData: action.payload,
      };
    }
    case "CLOSE_FILE_POP_UP": {
      return {
        ...state,
        dataMapFilePopUp: false,
        dataMapFilePopUpData: {},
      };
    }
    case SET_USER_AUDIT_TRAIL: {
      return {
        ...state,
        userAuditTrail: action.payload
      }
    }
    case SET_DATA_SOURCE_AUDIT_TRAIL: {
      return {
        ...state,
        dataSourceAuditTrail: action.payload
      }
    }
    default:
      return state;
  }
};
